import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "../context/AuthContext";

const LINKS = [
    { href: "/wireless", label: "Wireless plans", testid: "nav-wireless-link" },
    { href: "/second-number", label: "Second phone number", testid: "nav-second-number-link" },
    { href: "/deals", label: "Deals", testid: "nav-deals-link" },
    { href: "/watch", label: "Watch", testid: "nav-watch-link" },
    { href: "/franchise", label: "Dealers", testid: "nav-franchise-link" },
];

export const SiteNav = () => {
    const { user, startLogin } = useAuth();
    const navigate = useNavigate();
    const path = typeof window !== "undefined" ? window.location.pathname : "/";
    const [open, setOpen] = React.useState(false);
    return (
        <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FAF5FF]/80 border-b border-[#DDD6FE]">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
                <a href="/" className="flex items-center gap-3" data-testid="nav-brand">
                    <img src="/flexline-wordmark.svg" alt="FlexLine Mobile" className="h-9 w-auto" data-testid="nav-logo" />
                    <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-wider text-emerald-deep border-l border-[#DDD6FE] pl-3">Mobile · Wireless</span>
                </a>
                <nav className="hidden md:flex items-center gap-8 text-sm">
                    {LINKS.map((l) => (
                        <a key={l.href} href={l.href} data-testid={l.testid}
                            className={`link-underline transition-colors ${path === l.href ? "font-semibold text-[#4C1D95]" : "hover:text-[#4C1D95]"}`}>{l.label}</a>
                    ))}
                </nav>
                <div className="flex items-center gap-2">
                <button onClick={() => setOpen((o) => !o)} aria-label="Menu" data-testid="nav-mobile-menu-btn"
                    className="md:hidden w-9 h-9 grid place-items-center rounded-full border border-[#DDD6FE] text-[#4C1D95]">
                    {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
                </button>
                <Button data-testid="get-started-btn-nav" onClick={() => (user ? navigate("/dashboard") : startLogin())}
                    className="bg-[#4C1D95] text-white hover:bg-[#2E1065] rounded-full h-9 px-5 font-medium">
                    {user ? "Open app" : "Sign in"} <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
                </div>
            </div>
            {open && (
                <nav className="md:hidden border-t border-[#DDD6FE] bg-white px-6 py-3 flex flex-col" data-testid="nav-mobile-menu">
                    {LINKS.map((l) => (
                        <a key={l.href} href={l.href} data-testid={`${l.testid}-mobile`}
                            className={`py-3 border-b border-[#F3E8FF] last:border-0 ${path === l.href ? "font-semibold text-[#4C1D95]" : ""}`}>{l.label}</a>
                    ))}
                </nav>
            )}
        </header>
    );
};
